import { themeGet, TicketDetails } from '@tabeo/scarf'
import React, { useRef } from 'react'
import { useTheme } from 'styled-components'

const { Title: BaseTitle } = TicketDetails

function Title({ ...rest }) {
  const titleRef = useRef()
  const theme = useTheme()

  const { touched, error } = rest.meta

  return (
    <BaseTitle
      ref={titleRef}
      onKeyPress={e => {
        if (e.key === 'Enter') {
          titleRef.current.blur()
          e.preventDefault()
        }
      }}
      color="ink.0"
      borderColor={
        touched && error
          ? `${themeGet('colors.default.red')({ theme })} !important`
          : undefined
      }
      {...rest}
    />
  )
}

export default Title
